import React from "react";
import { motion } from "framer-motion";
import ProjectCard from "./ProjectCard";

import img1 from "../../assets/codex.png";
import img2 from "../../assets/br.png";
import img3 from "../../assets/gsw.png";
import img4 from "../../assets/data4x.png";
import img5 from "../../assets/ad.png";
import img6 from "../../assets/page9.png";

import "./style.css";

const projects = [
  {
    title: "Codex",
    description:
      "Codex is a headless CMS built for media houses, enabling flexible content management and seamless delivery across platforms.",
    image: img1,
    category: "Headless CMS",
    url: "https://codex.gjirafa.tech/",
  },
  {
    title: "Brazil Journal",
    description:
      "Brazil Journal is a digital publication providing reliable coverage of business, economics, and innovation in Brazil, with exclusive analysis and strategic insights.",
    image: img2,
    category: "News",
    url: "https://braziljournal.com/",
  },
  {
    title: "Global South World",
    description:
      "Global South World is a global news platform sharing stories and perspectives from around the world. It aims to provide diverse, timely coverage of global events.",
    image: img3,
    category: "News",
    url: "https://www.globalsouthworld.com/",
  },
  {
    title: "Data4x",
    description:
      "Data4X provides insights on Kosovo’s macroeconomic indicators, industries, and businesses, helping you make informed decisions and anticipate the future of your business.",
    image: img4,
    category: "Economy / Analytics",
    url: "https://www.data4x.com/",
  },
  {
    title: "Ad Network",
    description:
      "Gjirafa Ad Network is a digital advertising platform connecting brands with audiences across the Albanian-language web.",
    image: img5,
    category: "Ads",
    url: "https://client.gjirafa.com/landing",
  },
  {
    title: "Page9",
    description:
      "Page9 is a lifestyle magazine covering culture, trends, entertainment, and everyday life. It brings engaging stories and fresh perspectives to its audience.",
    image: img6,
    category: "Lifestyle",
    url: "https://page9.com.br/",
  },
];

const Projects = () => {
  return (
    <div className="">
      <div className="background-glow" />

      <div className="projects-container">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{
            duration: 0.8,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
          className="projects-header"
        >
          <p className="section-label">stuff I made</p>

          <h2 className="section-title">
            some of the things I’ve built and <br />
            <span className="gradient-text">
              helped bring to life.
            </span>
          </h2>
        </motion.div>

        <div className="projects-grid">
          {projects.map((project, i) => (
            <div
              key={project.title}
              className={`project-wrapper ${
                i % 3 === 1 ? "offset" : ""
              }`}
            >
              <ProjectCard
                {...project}
                index={i}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;